import QVEST_LOGO from "../../assets/company-logos/qvest.png";
import PPG_LOGO from "../../assets/company-logos/ppgindustries.png";
import BOEING_LOGO from "../../assets/company-logos/boeing.png";
import LADWP_LOGO from "../../assets/company-logos/ladwp.svg";
import REHRIG_LOGO from "../../assets/company-logos/rehrigpacificcompany.png";
import CADENCE_LOGO from "../../assets/company-logos/cadence.svg";
import GILEAD_LOGO from "../../assets/company-logos/gileadsciences.png";
import PENNAERO_LOGO from "../../assets/company-logos/pennaero.png";
import ACCENTURE_LOGO from "../../assets/company-logos/accenture.svg";
import FM_GLOBAL_LOGO from "../../assets/company-logos/fmglobal.png";
import APPLIED_MEDICAL_LOGO from "../../assets/company-logos/appliedmedical.svg";
import CHEVRON_LOGO from "../../assets/company-logos/chevron.svg";
import MOOG_LOGO from "../../assets/company-logos/moog.svg";

export const homeFeaturedCompanies = [
  { id: 1, name: "Qvest US", logo: QVEST_LOGO },
  { id: 2, name: "PPG", logo: PPG_LOGO },
  { id: 3, name: "Boeing", logo: BOEING_LOGO },
  { id: 4, name: "LADWP", logo: LADWP_LOGO },
  { id: 5, name: "Rehrig Pacific Company", logo: REHRIG_LOGO },
  { id: 6, name: "Cadence", logo: CADENCE_LOGO },
  { id: 7, name: "Gilead Sciences", logo: GILEAD_LOGO },
  { id: 8, name: "PennAero", logo: PENNAERO_LOGO },
  { id: 9, name: "Accenture", logo: ACCENTURE_LOGO },
  { id: 10, name: "FM Global", logo: FM_GLOBAL_LOGO },
  { id: 11, name: "Applied Medical", logo: APPLIED_MEDICAL_LOGO },
  { id: 12, name: "Chevron", logo: CHEVRON_LOGO },
  { id: 13, name: "Moog", logo: MOOG_LOGO },
];
